import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription, interval } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { SelfCheckInService } from '../../services/selfCheckIn.service';

@Component({
  templateUrl: 'success.component.html'
})
export class SuccessComponent implements OnInit, OnDestroy {

  selfGuestId: number;
  status: string = 'PENDING';
  message: string = '';
  private pollSub: Subscription;

  constructor(
    private activeRoute: ActivatedRoute,
    private selfCheckInService: SelfCheckInService
  ) { }

  ngOnInit() {
    this.selfGuestId = Number(this.activeRoute.snapshot.params['id']);
    if (!this.selfGuestId) {
      return;
    }

    this.pollSub = interval(4000).pipe(
      switchMap(() => this.selfCheckInService.getStatus(this.selfGuestId))
    ).subscribe(
      (data: any) => {
        this.status = data.status;
        this.message = data.message;
        if (this.status === 'ACCEPTED' || this.status === 'REJECTED') {
          if (this.pollSub) {
            this.pollSub.unsubscribe();
          }
        }
      },
      err => {
        // keep polling silently on transient errors; stop only on terminal states
      }
    );

    // fetch immediately once, don't wait for the first interval tick
    this.selfCheckInService.getStatus(this.selfGuestId).subscribe(
      (data: any) => {
        this.status = data.status;
        this.message = data.message;
      }
    );
  }

  ngOnDestroy() {
    if (this.pollSub) {
      this.pollSub.unsubscribe();
    }
  }
}
